<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import {
  dashboardComputed,
  dashboardListMethod,
  siteListMethod,
  siteListComputed,
  authComputed,
  collegeComputed,
  collegeListMethod,
} from '@state/helpers'
import formatDate from '@utils/format-date'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'

export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      lists: [],
      isLoading: true,
      active: false,
      siteconfiglist: [],
      platformId: 'All',
      dashboardData: {},
      allDashboardData: {},
      collegelist: [],
      isUserAdmin: false,
      collegeId: 'All',
      allCollegeList: [],
      chartOptions: {
        chart: {
          width: 380,
          type: 'pie',
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
        labels: ['Active Users', 'Inactive Users'],
      },
      chartOptions2: {
        chart: {
          width: 380,
          type: 'pie',
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
        labels: ['Registered', 'Not Registered'],
        colors: ['#008FFB', '#ff7848'],
      },
      fields: [
        { key: 'username', label: 'Name', sortable: true, colType: 'default' },
        {
          key: 'message',
          label: 'Message',
          sortable: true,
          colType: 'default',
        },
      ],
    }
  },
  computed: {
    ...dashboardComputed,
    ...siteListComputed,
    ...authComputed,
    ...collegeComputed,
  },
  mounted() {
    this.fetchSiteList()
    this.getDashboardData()
    this.getListOfPlatform()
    this.getColleges()
  },
  methods: {
    ...collegeListMethod,
    ...dashboardListMethod,
    ...siteListMethod,
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            ele.platform_id = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getColleges() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          college.docs.forEach((element) => {
            var ele = {}
            ele.text = element.name
            ele.value = element._id
            ele.platform_id = element.platform_id
            listitems.push(ele)
          })
          this.collegelist = listitems
          this.allCollegeList = listitems
        })
        .catch((_error) => {})
    },

    formatDates(date) {
      return formatDate(date)
    },
    getDashboardData() {
      const filter = {
        page: 1,
        limit: 10,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDashboardList({ filter })
        .then((data) => {
          this.dashboardData = JSON.parse(JSON.stringify(data))
          this.allDashboardData = JSON.parse(JSON.stringify(data))
          this.active = true
          this.createCharts()
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },

    getPlatformData() {
      this.collegeId = 'All'
      this.isUserAdmin = true
      let listitems = []
      listitems.push({ value: 'All', text: 'All' })
      this.allCollegeList.forEach((element) => {
        if (element.platform_id === Number(this.platformId)) {
          listitems.push(element)
        }
      })
      this.collegelist = listitems
      if (this.platformId !== 'All') {
        this.platformData()
      } else {
        this.allPlatformData()
      }
    },

    getCollegeData() {
      if (this.collegeId !== 'All') {
        let listitems = []
        let listitems1 = []
        for (
          let i = 0;
          i < this.allDashboardData.totalUser.totalCount.length;
          i++
        ) {
          if (
            this.allDashboardData.totalUser.totalCount[i].college_id ===
            this.collegeId
          ) {
            listitems.push(this.allDashboardData.totalUser.totalCount[i])
          }
        }
        for (
          let i = 0;
          i < this.allDashboardData.totalUser.totalUserWithCount.length;
          i++
        ) {
          if (
            this.allDashboardData.totalUser.totalUserWithCount[i].college_id ===
            this.collegeId
          ) {
            listitems1.push(
              this.allDashboardData.totalUser.totalUserWithCount[i]
            )
          }
        }
        this.dashboardData.totalUser.totalCount = listitems
        this.dashboardData.totalUser.totalUserWithCount = listitems1
        this.dashboardData.totalUser.activeUserCount = listitems1.length
        this.dashboardData.totalUser.inactiveUserCount =
          listitems.length - listitems1.length
        let list = []
        let list1 = []
        for (
          let i = 0;
          i < this.allDashboardData.allStudentData[0].total.length;
          i++
        ) {
          if (
            this.allDashboardData.allStudentData[0].total[i].college_id ===
              this.collegeId &&
            this.allDashboardData.allStudentData[0].total[i].status === true
          ) {
            list.push(this.allDashboardData.allStudentData[0].total[i])
          } else if (
            this.allDashboardData.allStudentData[0].total[i].college_id ===
              this.collegeId &&
            this.allDashboardData.allStudentData[0].total[i].status === false
          ) {
            list1.push(this.allDashboardData.allStudentData[0].total[i])
          }
        }
        this.dashboardData.allStudentData[0].registered = list.length
        this.dashboardData.allStudentData[0].notRegistered = list1.length
        list = []
        list1 = []
        for (let i = 0; i < this.allDashboardData.totalFeedback.length; i++) {
          if (
            this.allDashboardData.totalFeedback[i].college_id === this.collegeId
          ) {
            list.push(this.allDashboardData.totalFeedback[i])
          }
        }
        for (let i = 0; i < this.allDashboardData.allFeedback.length; i++) {
          if (
            this.allDashboardData.allFeedback[i].college_id === this.collegeId
          ) {
            list1.push(this.allDashboardData.allFeedback[i])
          }
        }
        this.dashboardData.totalFeedback = list
        this.dashboardData.totalFeedbackCount = list.length
        this.dashboardData.allFeedback = list1
        list = []
        for (let i = 0; i < this.allDashboardData.dailyLoginCount.length; i++) {
          list = []
          for (
            let j = 0;
            j < this.allDashboardData.dailyLoginCount[i].allData.length;
            j++
          ) {
            if (
              this.allDashboardData.dailyLoginCount[i].allData[j].college_id ===
              this.collegeId
            ) {
              list.push(this.allDashboardData.dailyLoginCount[i].allData[j])
            }
          }
          this.dashboardData.dailyLoginCount[i].count = list.length
        }
        list = []
        for (let i = 0; i < this.allDashboardData.courseData.length; i++) {
          if (
            this.allDashboardData.courseData[i].college_id === this.collegeId
          ) {
            list.push(this.allDashboardData.courseData[i])
          }
        }
        this.dashboardData.courseData = list
        // Course
        list = []
        for (let i = 0; i < this.allDashboardData.totalCourse.length; i++) {
          if (
            this.allDashboardData.totalCourse[i].college_id === this.collegeId
          ) {
            list.push(this.allDashboardData.totalCourse[i])
          }
        }
        this.dashboardData.totalCourse = list
        this.dashboardData.totalCourseCount = list.length
        list = []
        for (
          let i = 0;
          i < this.allDashboardData.courseCategoryCount.length;
          i++
        ) {
          list = []
          for (
            let j = 0;
            j <
            this.allDashboardData.courseCategoryCount[i].allCourseData.length;
            j++
          ) {
            if (
              this.allDashboardData.courseCategoryCount[i].allCourseData[j]
                .college_id === this.collegeId
            ) {
              list.push(
                this.allDashboardData.courseCategoryCount[i].allCourseData[j]
              )
            }
          }
          this.dashboardData.courseCategoryCount[i].count = list.length
        }
        // Event
        list = []
        for (let i = 0; i < this.allDashboardData.totalEvent.length; i++) {
          if (
            this.allDashboardData.totalEvent[i].college_id === this.collegeId
          ) {
            list.push(this.allDashboardData.totalEvent[i])
          }
        }
        this.dashboardData.totalEvent = list
        this.dashboardData.totalEventCount = list.length
        list = []
        for (
          let i = 0;
          i < this.allDashboardData.eventCategoryCount.length;
          i++
        ) {
          list = []
          for (
            let j = 0;
            j < this.allDashboardData.eventCategoryCount[i].allEventData.length;
            j++
          ) {
            if (
              this.allDashboardData.eventCategoryCount[i].allEventData[j]
                .college_id === this.collegeId
            ) {
              list.push(
                this.allDashboardData.eventCategoryCount[i].allEventData[j]
              )
            }
          }
          this.dashboardData.eventCategoryCount[i].count = list.length
        }
        // Blog
        list = []
        for (let i = 0; i < this.allDashboardData.totalBlog.length; i++) {
          if (
            this.allDashboardData.totalBlog[i].college_id === this.collegeId
          ) {
            list.push(this.allDashboardData.totalBlog[i])
          }
        }
        this.dashboardData.totalBlog = list
        this.dashboardData.totalBlogCount = list.length
        list = []
        for (
          let i = 0;
          i < this.allDashboardData.blogCategoryCount.length;
          i++
        ) {
          list = []
          for (
            let j = 0;
            j < this.allDashboardData.blogCategoryCount[i].allBlogData.length;
            j++
          ) {
            if (
              this.allDashboardData.blogCategoryCount[i].allBlogData[j]
                .college_id === this.collegeId
            ) {
              list.push(
                this.allDashboardData.blogCategoryCount[i].allBlogData[j]
              )
            }
          }
          this.dashboardData.blogCategoryCount[i].count = list.length
        }
        this.createCharts()
      } else if (this.platformId !== 'All') {
        this.platformData()
      } else if (this.platformId === 'All') {
        this.allPlatformData()
      }
    },

    platformData() {
      let listitems = []
      let listitems1 = []
      for (
        let i = 0;
        i < this.allDashboardData.totalUser.totalCount.length;
        i++
      ) {
        if (
          this.allDashboardData.totalUser.totalCount[i].platform_id ===
          Number(this.platformId)
        ) {
          listitems.push(this.allDashboardData.totalUser.totalCount[i])
        }
      }
      for (
        let i = 0;
        i < this.allDashboardData.totalUser.totalUserWithCount.length;
        i++
      ) {
        if (
          this.allDashboardData.totalUser.totalUserWithCount[i].platform_id ===
          Number(this.platformId)
        ) {
          listitems1.push(this.allDashboardData.totalUser.totalUserWithCount[i])
        }
      }
      this.dashboardData.totalUser.totalCount = listitems
      this.dashboardData.totalUser.totalUserWithCount = listitems1
      this.dashboardData.totalUser.activeUserCount = listitems1.length
      this.dashboardData.totalUser.inactiveUserCount =
        listitems.length - listitems1.length
      let list = []
      let list1 = []
      for (
        let i = 0;
        i < this.allDashboardData.allStudentData[0].total.length;
        i++
      ) {
        if (
          this.allDashboardData.allStudentData[0].total[i].platform_id ===
            Number(this.platformId) &&
          this.allDashboardData.allStudentData[0].total[i].status === true
        ) {
          list.push(this.allDashboardData.allStudentData[0].total[i])
        } else if (
          this.allDashboardData.allStudentData[0].total[i].platform_id ===
            Number(this.platformId) &&
          this.allDashboardData.allStudentData[0].total[i].status === false
        ) {
          list1.push(this.allDashboardData.allStudentData[0].total[i])
        }
      }
      this.dashboardData.allStudentData[0].registered = list.length
      this.dashboardData.allStudentData[0].notRegistered = list1.length
      list = []
      list1 = []
      for (let i = 0; i < this.allDashboardData.totalFeedback.length; i++) {
        if (
          this.allDashboardData.totalFeedback[i].platform_id ===
          Number(this.platformId)
        ) {
          list.push(this.allDashboardData.totalFeedback[i])
        }
      }
      for (let i = 0; i < this.allDashboardData.allFeedback.length; i++) {
        if (
          this.allDashboardData.allFeedback[i].platform_id ===
          Number(this.platformId)
        ) {
          list1.push(this.allDashboardData.allFeedback[i])
        }
      }
      this.dashboardData.totalFeedback = list
      this.dashboardData.totalFeedbackCount = list.length
      this.dashboardData.allFeedback = list1
      list = []
      for (let i = 0; i < this.allDashboardData.dailyLoginCount.length; i++) {
        list = []
        for (
          let j = 0;
          j < this.allDashboardData.dailyLoginCount[i].allData.length;
          j++
        ) {
          if (
            this.allDashboardData.dailyLoginCount[i].allData[j].platform_id ===
            Number(this.platformId)
          ) {
            list.push(this.allDashboardData.dailyLoginCount[i].allData[j])
          }
        }
        this.dashboardData.dailyLoginCount[i].count = list.length
      }
      list = []
      for (let i = 0; i < this.allDashboardData.courseData.length; i++) {
        if (
          this.allDashboardData.courseData[i].platform_id.includes(
            Number(this.platformId)
          )
        ) {
          list.push(this.allDashboardData.courseData[i])
        }
      }
      this.dashboardData.courseData = list
      // Course
      list = []
      for (let i = 0; i < this.allDashboardData.totalCourse.length; i++) {
        if (
          this.allDashboardData.totalCourse[i].platform_id.includes(
            Number(this.platformId)
          )
        ) {
          list.push(this.allDashboardData.totalCourse[i])
        }
      }
      this.dashboardData.totalCourse = list
      this.dashboardData.totalCourseCount = list.length
      list = []
      for (
        let i = 0;
        i < this.allDashboardData.courseCategoryCount.length;
        i++
      ) {
        list = []
        for (
          let j = 0;
          j < this.allDashboardData.courseCategoryCount[i].allCourseData.length;
          j++
        ) {
          if (
            this.allDashboardData.courseCategoryCount[i].allCourseData[
              j
            ].platform_id.includes(Number(this.platformId))
          ) {
            list.push(
              this.allDashboardData.courseCategoryCount[i].allCourseData[j]
            )
          }
        }
        this.dashboardData.courseCategoryCount[i].count = list.length
      }
      // Event
      list = []
      for (let i = 0; i < this.allDashboardData.totalEvent.length; i++) {
        if (
          this.allDashboardData.totalEvent[i].platform_id.includes(
            Number(this.platformId)
          )
        ) {
          list.push(this.allDashboardData.totalEvent[i])
        }
      }
      this.dashboardData.totalEvent = list
      this.dashboardData.totalEventCount = list.length
      list = []
      for (
        let i = 0;
        i < this.allDashboardData.eventCategoryCount.length;
        i++
      ) {
        list = []
        for (
          let j = 0;
          j < this.allDashboardData.eventCategoryCount[i].allEventData.length;
          j++
        ) {
          if (
            this.allDashboardData.eventCategoryCount[i].allEventData[
              j
            ].platform_id.includes(Number(this.platformId))
          ) {
            list.push(
              this.allDashboardData.eventCategoryCount[i].allEventData[j]
            )
          }
        }
        this.dashboardData.eventCategoryCount[i].count = list.length
      }
      // Blog
      list = []
      for (let i = 0; i < this.allDashboardData.totalBlog.length; i++) {
        if (
          this.allDashboardData.totalBlog[i].platform_id.includes(
            Number(this.platformId)
          )
        ) {
          list.push(this.allDashboardData.totalBlog[i])
        }
      }
      this.dashboardData.totalBlog = list
      this.dashboardData.totalBlogCount = list.length
      list = []
      for (let i = 0; i < this.allDashboardData.blogCategoryCount.length; i++) {
        list = []
        for (
          let j = 0;
          j < this.allDashboardData.blogCategoryCount[i].allBlogData.length;
          j++
        ) {
          if (
            this.allDashboardData.blogCategoryCount[i].allBlogData[
              j
            ].platform_id.includes(Number(this.platformId))
          ) {
            list.push(this.allDashboardData.blogCategoryCount[i].allBlogData[j])
          }
        }
        this.dashboardData.blogCategoryCount[i].count = list.length
      }
      this.createCharts()
    },

    allPlatformData() {
      this.dashboardData.totalUser.totalCount = this.allDashboardData.totalUser.totalCount
      this.dashboardData.totalUser.totalUserWithCount = this.allDashboardData.totalUser.totalUserWithCount
      this.dashboardData.totalUser.activeUserCount = this.allDashboardData.totalUser.activeUserCount
      this.dashboardData.totalUser.inactiveUserCount = this.allDashboardData.totalUser.inactiveUserCount
      this.dashboardData.allStudentData[0].registered = this.allDashboardData.allStudentData[0].registered
      this.dashboardData.allStudentData[0].notRegistered = this.allDashboardData.allStudentData[0].notRegistered
      this.dashboardData.allFeedback = this.allDashboardData.allFeedback
      this.dashboardData.totalFeedback = this.allDashboardData.totalFeedback
      this.dashboardData.totalFeedbackCount = this.allDashboardData.totalFeedbackCount
      for (let i = 0; i < this.allDashboardData.dailyLoginCount.length; i++) {
        let list = []
        for (
          let j = 0;
          j < this.allDashboardData.dailyLoginCount[i].allData.length;
          j++
        ) {
          list.push(this.allDashboardData.dailyLoginCount[i].allData[j])
        }
        this.dashboardData.dailyLoginCount[i].count = list.length
      }
      this.dashboardData.courseData = this.allDashboardData.courseData
      this.dashboardData.totalCourse = this.allDashboardData.totalCourse
      this.dashboardData.totalCourseCount = this.allDashboardData.totalCourseCount
      for (
        let i = 0;
        i < this.allDashboardData.courseCategoryCount.length;
        i++
      ) {
        let list = []
        for (
          let j = 0;
          j < this.allDashboardData.courseCategoryCount[i].allCourseData.length;
          j++
        ) {
          list.push(
            this.allDashboardData.courseCategoryCount[i].allCourseData[j]
          )
        }
        this.dashboardData.courseCategoryCount[i].count = list.length
      }
      this.dashboardData.totalEvent = this.allDashboardData.totalEvent
      this.dashboardData.totalEventCount = this.allDashboardData.totalEventCount
      for (
        let i = 0;
        i < this.allDashboardData.eventCategoryCount.length;
        i++
      ) {
        let list = []
        for (
          let j = 0;
          j < this.allDashboardData.eventCategoryCount[i].allEventData.length;
          j++
        ) {
          list.push(this.allDashboardData.eventCategoryCount[i].allEventData[j])
        }
        this.dashboardData.eventCategoryCount[i].count = list.length
      }
      this.dashboardData.totalBlog = this.allDashboardData.totalBlog
      this.dashboardData.totalBlogCount = this.allDashboardData.totalBlogCount
      for (let i = 0; i < this.allDashboardData.blogCategoryCount.length; i++) {
        let list = []
        for (
          let j = 0;
          j < this.allDashboardData.blogCategoryCount[i].allBlogData.length;
          j++
        ) {
          list.push(this.allDashboardData.blogCategoryCount[i].allBlogData[j])
        }
        this.dashboardData.blogCategoryCount[i].count = list.length
      }
      this.createCharts()
    },

    // create pie chart for user status
    createCharts() {
      // Piechart 1
      if (
        this.role === 'admin' ||
        this.role === 'administrator' ||
        this.role === 'college'
      ) {
        let chart = am4core.create(this.$refs.chart1, am4charts.PieChart)
        chart.legend = new am4charts.Legend()
        chart.legend.position = 'bottom'
        chart.legend.labels.template.text = '{category} ({count})'
        chart.data = [
          {
            User: 'Active Users',
            count: this.dashboardData.totalUser.activeUserCount
              ? Math.abs(this.dashboardData.totalUser.activeUserCount)
              : 0,
          },
          {
            User: 'Inactive Users',
            count: this.dashboardData.totalUser.inactiveUserCount
              ? Math.abs(this.dashboardData.totalUser.inactiveUserCount)
              : 0,
          },
        ]
        let series = chart.series.push(new am4charts.PieSeries())
        series.labels.template.disabled = true
        series.ticks.template.disabled = true
        series.dataFields.value = 'count'
        series.dataFields.category = 'User'
        let colorSet1 = new am4core.ColorSet()
        colorSet1.list = ['#7481cf', '#8453a1', '#8E24AA'].map(function(color) {
          // eslint-disable-next-line new-cap
          return new am4core.color(color)
        })
        series.colors = colorSet1
      }

      // Piechart 2
      if (this.role === 'admin' || this.role === 'administrator') {
        let chart1 = am4core.create(this.$refs.chart2, am4charts.PieChart)
        chart1.legend = new am4charts.Legend()
        chart1.legend.position = 'bottom'
        chart1.legend.labels.template.text = '{category} ({count})'

        chart1.data = [
          {
            Student: 'Registered',
            count:
              this.dashboardData.allStudentData[0].registered !== undefined
                ? Math.abs(this.dashboardData.allStudentData[0].registered)
                : 0,
          },
          {
            Student: 'Not Registered',
            count:
              this.dashboardData.allStudentData[0].notRegistered !== undefined
                ? Math.abs(this.dashboardData.allStudentData[0].notRegistered)
                : 0,
          },
        ]
        let series1 = chart1.series.push(new am4charts.PieSeries())
        series1.labels.template.disabled = true
        series1.ticks.template.disabled = true
        series1.dataFields.value = 'count'
        series1.dataFields.category = 'Student'
        let colorSet = new am4core.ColorSet()
        colorSet.list = [
          '#cdb6ef',
          '#8b65ce',
          '#0288d1',
          '#F44336',
          '#8E24AA',
        ].map(function(color) {
          // eslint-disable-next-line new-cap
          return new am4core.color(color)
        })
        series1.colors = colorSet
      }

      // Login Count chart
      if (
        this.role === 'admin' ||
        this.role === 'administrator' ||
        this.role === 'college'
      ) {
        let chart3 = am4core.create(this.$refs.chart3, am4charts.XYChart)
        chart3.data = this.dashboardData.dailyLoginCount
        let categoryAxis = chart3.xAxes.push(new am4charts.CategoryAxis())
        categoryAxis.dataFields.category = 'date'
        categoryAxis.renderer.grid.template.location = 0
        categoryAxis.renderer.minGridDistance = 30
        let label = categoryAxis.renderer.labels.template
        label.wrap = true
        label.maxWidth = 60

        // categoryAxis.renderer.labels.template.adapter.add('dy', function(
        //   dy,
        //   target
        // ) {
        //   if (target.dataItem && target.dataItem.index === 2) {
        //     return dy + 25
        //   }
        //   return dy
        // })

        chart3.yAxes.push(new am4charts.ValueAxis())

        // Create series
        let series3 = chart3.series.push(new am4charts.ColumnSeries())
        series3.dataFields.valueY = 'count'
        series3.dataFields.categoryX = 'date'
        series3.name = 'Login Counts'
        series3.columns.template.tooltipText = '{categoryX}: [bold]{valueY}[/]'
        series3.columns.template.fillOpacity = 0.8
        series3.columns.template.stroke = am4core.color('#000000')
        series3.columns.template.fill = am4core.color('#8b65ce')
        let columnTemplate1 = series3.columns.template
        columnTemplate1.strokeWidth = 2
        columnTemplate1.strokeOpacity = 1
      }
      // Course Chart
      if (
        this.role === 'admin' ||
        this.role === 'administrator' ||
        this.role === 'college'
      ) {
        let chart4 = am4core.create(this.$refs.chart4, am4charts.XYChart)
        chart4.data = this.dashboardData.courseData
        let categoryAxis1 = chart4.xAxes.push(new am4charts.CategoryAxis())
        categoryAxis1.dataFields.category = 'name'
        categoryAxis1.renderer.grid.template.location = 0
        categoryAxis1.renderer.minGridDistance = 30
        let label = categoryAxis1.renderer.labels.template
        label.truncate = true
        if (this.dashboardData.courseData.length > 15) {
          label.maxWidth = 50
        } else {
          label.maxWidth = 80
        }
        label.tooltipText = '{category}'
        // categoryAxis1.renderer.labels.template.adapter.add('dy', function(
        //   dy,
        //   target
        // ) {
        //   if (target.dataItem && target.dataItem.index === 2) {
        //     return dy + 25
        //   }
        //   return dy
        // })

        chart4.yAxes.push(new am4charts.ValueAxis())

        // Create series
        let series4 = chart4.series.push(new am4charts.ColumnSeries())
        series4.dataFields.valueY = 'totalview'
        series4.dataFields.categoryX = 'name'
        series4.name = 'Login Counts'
        series4.columns.template.tooltipText = '{categoryX}: [bold]{valueY}[/]'
        series4.columns.template.fillOpacity = 0.8
        series4.columns.template.stroke = am4core.color('#000000')
        series4.columns.template.fill = am4core.color('#cdb6ef')
        let columnTemplate = series4.columns.template
        columnTemplate.strokeWidth = 2
        columnTemplate.strokeOpacity = 1
      }
      // Assignment Chart
      if (this.role !== 'admin' || this.role !== 'administrator') {
        let chart5 = am4core.create(this.$refs.chart5, am4charts.XYChart)
        chart5.colors.step = 2

        chart5.legend = new am4charts.Legend()
        chart5.legend.position = 'top'
        chart5.legend.paddingBottom = 20
        chart5.legend.labels.template.maxWidth = 95
        let xAxis = chart5.xAxes.push(new am4charts.CategoryAxis())
        xAxis.dataFields.category = 'name'
        xAxis.renderer.cellStartLocation = 0.1
        xAxis.renderer.cellEndLocation = 0.9
        xAxis.renderer.grid.template.location = 0
        let label = xAxis.renderer.labels.template
        label.truncate = true
        label.maxWidth = 60
        label.tooltipText = '{category}'
        let yAxis = chart5.yAxes.push(new am4charts.ValueAxis())
        yAxis.min = 0

        let createSeries
        createSeries = function createSeries(value, name, color) {
          let series = chart5.series.push(new am4charts.ColumnSeries())
          series.dataFields.valueY = value
          series.dataFields.categoryX = 'name'
          series.name = name

          series.events.on('hidden', arrangeColumns)
          series.events.on('shown', arrangeColumns)

          let bullet = series.bullets.push(new am4charts.LabelBullet())
          bullet.interactionsEnabled = false
          bullet.dy = 20
          bullet.label.text = '{valueY}'
          bullet.label.fill = am4core.color('#ffffff')
          series.columns.template.stroke = am4core.color('#000000')
          series.columns.template.fill = am4core.color(color)
          return series
        }
        chart5.data = this.dashboardData.assignmentData
        createSeries('assigned_to', 'Total Students', '#8f8ff7')
        createSeries('responsesCount', 'Submitted', '#95db95')
        createSeries('remaining', 'Not Submitted', '#f75656')

        let arrangeColumns = function arrangeColumns() {
          let series = chart5.series.getIndex(0)

          let w =
            1 -
            xAxis.renderer.cellStartLocation -
            (1 - xAxis.renderer.cellEndLocation)
          if (series.dataItems.length > 1) {
            let x0 = xAxis.getX(series.dataItems.getIndex(0), 'categoryX')
            let x1 = xAxis.getX(series.dataItems.getIndex(1), 'categoryX')
            let delta = ((x1 - x0) / chart5.series.length) * w
            if (am4core.isNumber(delta)) {
              let middle = chart5.series.length / 2

              let newIndex = 0
              chart5.series.each(function(series) {
                if (!series.isHidden && !series.isHiding) {
                  series.dummyData = newIndex
                  newIndex++
                } else {
                  series.dummyData = chart5.series.indexOf(series)
                }
              })
              let visibleCount = newIndex
              let newMiddle = visibleCount / 2

              chart5.series.each(function(series) {
                let trueIndex = chart5.series.indexOf(series)
                let newIndex = series.dummyData

                let dx = (newIndex - trueIndex + middle - newMiddle) * delta

                series.animate(
                  { property: 'dx', to: dx },
                  series.interpolationDuration,
                  series.interpolationEasing
                )
                series.bulletsContainer.animate(
                  { property: 'dx', to: dx },
                  series.interpolationDuration,
                  series.interpolationEasing
                )
              })
            }
          }
        }
      }
    },

    // Placeholder Pie Chart
    createPlaceholderPieChart() {
      let chart = am4core.create(this.$refs.chart1, am4charts.PieChart)
      /* Dummy innitial data data */
      chart.data = [
        {
          country: 'Dummy',
          disabled: true,
          value: 1000,
          color: am4core.color('#dadada'),
          opacity: 0.3,
          strokeDasharray: '4,4',
          tooltip: '',
        },
      ]

      /* Create series */
      var series = chart.series.push(new am4charts.PieSeries())
      series.dataFields.value = 'value'
      series.dataFields.category = 'country'

      /* Set tup slice appearance */
      var slice = series.slices.template
      slice.propertyFields.fill = 'color'
      slice.propertyFields.fillOpacity = 'opacity'
      slice.propertyFields.stroke = 'color'
      slice.propertyFields.strokeDasharray = 'strokeDasharray'
      slice.propertyFields.tooltipText = 'tooltip'

      series.labels.template.propertyFields.disabled = 'disabled'
      series.ticks.template.propertyFields.disabled = 'disabled'
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div
        v-if="role === 'admin' || role === 'administrator'"
        class="col-md-12"
      >
        <b-form-group
          v-if="role === 'admin'"
          label="Select Platform"
          label-for="input-1"
        >
          <b-form-select
            v-model="platformId"
            :options="siteconfiglist"
            @change="getPlatformData"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          v-if="(role === 'admin' && isUserAdmin) || role === 'administrator'"
          label="Select College"
          label-for="input-1"
        >
          <b-form-select
            v-model="collegeId"
            :options="collegelist"
            @change="getCollegeData"
          ></b-form-select>
        </b-form-group>
      </div>
      <div
        v-if="
          role === 'admin' || role === 'administrator' || role === 'college'
        "
        class="col-md-6"
      >
        <b-overlay :show="!active" :opacity="0.6" rounded="sm">
          <div class="card-box widget-user">
            <b><center>Active/Inactive Users Count </center></b>
            <div ref="chart1" class="piechart1"></div>
          </div>
        </b-overlay>
      </div>
      <div v-if="role === 'admin' || role === 'administrator'" class="col-md-6">
        <b-overlay :show="!active" :opacity="0.6" rounded="sm">
          <div class="card-box widget-user">
            <b><center>Registration Count </center></b>
            <div ref="chart2" class="piechart2"></div>
          </div>
        </b-overlay>
      </div>
      <div
        v-if="role === 'admin' || role === 'administrator'"
        class="col-md-12"
      >
        <b-overlay :show="!active" :opacity="0.6" rounded="sm">
          <div class="card-box widget-user">
            <b><center>Daily Login Count (Last 15 days) </center></b>
            <div ref="chart3" class="piechart1"></div>
          </div>
        </b-overlay>
      </div>
      <div v-if="role === 'college'" class="col-md-6">
        <b-overlay :show="!active" :opacity="0.6" rounded="sm">
          <div class="card-box widget-user">
            <b><center>Daily Login Count (Last 15 days) </center></b>
            <div ref="chart3" class="piechart1"></div>
          </div>
        </b-overlay>
      </div>
      <div
        v-if="role === 'admin' || role === 'administrator'"
        class="col-md-12"
      >
        <b-overlay :show="!active" :opacity="0.6" rounded="sm">
          <div class="card-box widget-user">
            <b><center>Course Views (Last 7 days)</center></b>
            <div ref="chart4" class="piechart1"></div>
          </div>
        </b-overlay>
      </div>
      <div v-if="role === 'college'" class="col-md-12">
        <b-overlay :show="!active" :opacity="0.6" rounded="sm">
          <div class="card-box widget-user">
            <b><center>Course Views (Last 7 days)</center></b>
            <div ref="chart4" class="piechart1"></div>
          </div>
        </b-overlay>
      </div>
      <div
        v-if="role !== 'admin' && role !== 'administrator'"
        class="col-md-12"
      >
        <b-overlay :show="!active" :opacity="0.6" rounded="sm">
          <div class="card-box widget-user">
            <b><center>Assignments Report</center></b>
            <div ref="chart5" class="piechart1"></div>
          </div>
        </b-overlay>
      </div>
      <div
        v-if="role === 'admin' || role === 'administrator'"
        class="col-md-12"
      >
        <div class="row">
          <div class="col-xl-4 col-md-4">
            <div class="card-box widget-user">
              <b-overlay :show="!active" :opacity="0.6" rounded="sm">
                <div class="row details">
                  <div
                    class="col-md-5 align-items-center d-flex justify-content-center"
                  >
                    <div class="text-center">
                      <a href="/course-list">
                        <h1
                          class="font-weight-normal text-primary"
                          data-plugin="counterup"
                          >{{ dashboardData.totalCourseCount }}</h1
                        >
                        <h3>Courses</h3>
                      </a>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <ul class="list-group mb-0 user-list courses">
                      <li
                        v-for="(item,
                        index) in dashboardData.courseCategoryCount"
                        :key="index"
                        class="list-group-item"
                      >
                        <div class="user-list-item">
                          <div class="user float-left mr-3">
                            <i class="mdi mdi-circle text-primary"></i>
                          </div>
                          <div class="user-desc overflow-hidden">
                            <p class="text-muted font-13 mt-0 mb-1"
                              >{{ item._id[0] }} ({{ item.count }})</p
                            >
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
          <div class="col-xl-4 col-md-4">
            <div class="card-box widget-user">
              <b-overlay :show="!active" :opacity="0.6" rounded="sm">
                <div class="row details">
                  <div
                    class="col-md-5 align-items-center d-flex justify-content-center"
                  >
                    <div class="text-center">
                      <a href="/event-list">
                        <h1
                          class="font-weight-normal text-danger"
                          data-plugin="counterup"
                          >{{ dashboardData.totalEventCount }}</h1
                        >
                        <h3>Events</h3></a
                      >
                    </div>
                  </div>
                  <div class="col-md-7">
                    <ul class="list-group mb-0 user-list events">
                      <li
                        v-for="(item,
                        index) in dashboardData.eventCategoryCount"
                        :key="index"
                        class="list-group-item"
                      >
                        <div class="user-list-item">
                          <div class="user float-left mr-3">
                            <i class="mdi mdi-circle text-danger"></i>
                          </div>
                          <div class="user-desc overflow-hidden">
                            <p class="text-muted font-13 mt-0 mb-1"
                              >{{ item._id[0] }} ({{ item.count }})</p
                            >
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
          <div class="col-xl-4 col-md-4">
            <div class="card-box widget-user">
              <b-overlay :show="!active" :opacity="0.6" rounded="sm">
                <div class="row details">
                  <div
                    class="col-md-5 align-items-center d-flex justify-content-center"
                  >
                    <div class="text-center">
                      <a href="/blog-list">
                        <h1
                          class="font-weight-normal text-warning"
                          data-plugin="counterup"
                          >{{ dashboardData.totalBlogCount }}</h1
                        >
                        <h3>Blogs</h3>
                      </a>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <ul class="list-group mb-0 user-list blogs">
                      <li
                        v-for="(item, index) in dashboardData.blogCategoryCount"
                        :key="index"
                        class="list-group-item"
                      >
                        <div class="user-list-item">
                          <div class="user float-left mr-2">
                            <i class="mdi mdi-circle text-warning"></i>
                          </div>
                          <div class="user-desc overflow-hidden">
                            <p class="text-muted font-13 mt-0 mb-1"
                              >{{ item._id[0] }} ({{ item.count }})</p
                            >
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="role === 'hod' || role === 'teacher'" class="col-md-12">
        <div class="row">
          <div class="col-xl-4 col-md-4">
            <div class="card-box widget-user">
              <b-overlay :show="!active" :opacity="0.6" rounded="sm">
                <div class="row details">
                  <div
                    class="col-md-12 align-items-center d-flex justify-content-center"
                  >
                    <div class="text-center">
                      <a href="/resource-list">
                        <h1
                          class="font-weight-normal text-primary"
                          data-plugin="counterup"
                          >{{ dashboardData.totalResource }}</h1
                        >
                        <h3>Resources</h3></a
                      >
                    </div>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
          <div class="col-xl-4 col-md-4">
            <div class="card-box widget-user">
              <b-overlay :show="!active" :opacity="0.6" rounded="sm">
                <div class="row details">
                  <div
                    class="col-md-12 align-items-center d-flex justify-content-center"
                  >
                    <div class="text-center">
                      <a href="/assignment-list">
                        <h1
                          class="font-weight-normal text-danger"
                          data-plugin="counterup"
                          >{{ dashboardData.totalAssignment }}</h1
                        >
                        <h3>Assignments</h3></a
                      >
                    </div>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
          <div class="col-xl-4 col-md-4">
            <div class="card-box widget-user">
              <b-overlay :show="!active" :opacity="0.6" rounded="sm">
                <div class="row details">
                  <div
                    class="col-md-12 align-items-center d-flex justify-content-center"
                  >
                    <div class="text-center">
                      <a href="/blog-list">
                        <h1
                          class="font-weight-normal text-warning"
                          data-plugin="counterup"
                          >{{ dashboardData.totalBlogCount }}</h1
                        >
                        <h3>Blogs</h3></a
                      >
                    </div>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="col-md-12">
        <div class="row">
          <div class="col-xl-4 col-md-4">
            <div class="card-box widget-user">
              <b-overlay :show="!active" :opacity="0.6" rounded="sm">
                <div class="row details">
                  <div
                    class="col-md-12 align-items-center d-flex justify-content-center"
                  >
                    <div class="text-center">
                      <a href="/course-list">
                        <h1
                          class="font-weight-normal text-primary"
                          data-plugin="counterup"
                          >{{ dashboardData.totalCourseCount }}</h1
                        >
                        <h3>Course</h3></a
                      >
                    </div>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
          <div class="col-xl-4 col-md-4">
            <div class="card-box widget-user">
              <b-overlay :show="!active" :opacity="0.6" rounded="sm">
                <div class="row details">
                  <div
                    class="col-md-12 align-items-center d-flex justify-content-center"
                  >
                    <div class="text-center">
                      <a href="/event-list">
                        <h1
                          class="font-weight-normal text-primary"
                          data-plugin="counterup"
                          >{{ dashboardData.totalEventCount }}</h1
                        >
                        <h3>Upcoming Events</h3></a
                      >
                    </div>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
          <div class="col-xl-4 col-md-4">
            <div class="card-box widget-user">
              <b-overlay :show="!active" :opacity="0.6" rounded="sm">
                <div class="row details">
                  <div
                    class="col-md-12 align-items-center d-flex justify-content-center"
                  >
                    <div class="text-center">
                      <a href="/blog-list">
                        <h1
                          class="font-weight-normal text-warning"
                          data-plugin="counterup"
                          >{{ dashboardData.totalBlogCount }}</h1
                        >
                        <h3>Blogs</h3></a
                      >
                    </div>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
          <div class="col-xl-6 col-md-6">
            <div class="card-box widget-user">
              <b-overlay :show="!active" :opacity="0.6" rounded="sm">
                <div class="row details">
                  <div
                    class="col-md-12 align-items-center d-flex justify-content-center"
                  >
                    <div class="text-center">
                      <a href="/resource-list">
                        <h1
                          class="font-weight-normal text-primary"
                          data-plugin="counterup"
                          >{{ dashboardData.totalResource }}</h1
                        >
                        <h3>Resources</h3></a
                      >
                    </div>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
          <div class="col-xl-6 col-md-6">
            <div class="card-box widget-user">
              <b-overlay :show="!active" :opacity="0.6" rounded="sm">
                <div class="row details">
                  <div
                    class="col-md-12 align-items-center d-flex justify-content-center"
                  >
                    <div class="text-center">
                      <a href="/assignment-list">
                        <h1
                          class="font-weight-normal text-danger"
                          data-plugin="counterup"
                          >{{ dashboardData.totalAssignment }}</h1
                        >
                        <h3>Assignments</h3></a
                      >
                    </div>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="role === 'admin' || role === 'administrator'"
        class="col-md-12"
      >
        <div class="card">
          <div class="card-body">
            <h4 class="card-title text-center mb-4">
              User Feedbacks ({{ dashboardData.totalFeedbackCount }})
            </h4>
            <div class="row">
              <div
                v-for="(item, index) in dashboardData.allFeedback"
                :key="index"
                class="col-md-4"
              >
                <blockquote class="blockquote font-16 mb-3">
                  <p>{{ item.message }}</p>
                  <p>
                    <star-rating
                      v-if="item.rating"
                      :rating="item.rating"
                      read-only
                      :round-start-rating="false"
                      :star-size="12"
                    ></star-rating>
                  </p>
                  <footer class="blockquote-footer">
                    {{ item.username }},
                    <cite class="pl-1" title="Date">{{
                      formatDates(item.createdAt)
                    }}</cite>
                  </footer>
                </blockquote>
              </div>
              <div
                v-if="
                  dashboardData.allFeedback &&
                    dashboardData.allFeedback.length > 0
                "
                class="col-md-12 text-center"
              >
                <b-button size="md" variant="primary" to="/report-list/feedback"
                  >Read More</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.piechart1 {
  height: 250px;
}
.piechart2 {
  height: 250px;
}
.card-box {
  min-height: 190px;
}
.card-box .col-md-5 {
  height: 142px;
}
.list-group-item {
  padding: 0.35rem 0.55rem;
}
.details {
  min-height: 250px;
}
.h-300 {
  height: 300px;
}
.courses,
.blogs,
.events {
  height: 250px;
  overflow-y: auto;
}
.courses::-webkit-scrollbar {
  width: 2px;
}
.courses::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.courses::-webkit-scrollbar-thumb {
  background: #71b6f9;
}
.blogs::-webkit-scrollbar {
  width: 2px;
}
.blogs::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.blogs::-webkit-scrollbar-thumb {
  background: #f9c851;
}
.events::-webkit-scrollbar {
  width: 2px;
}
.events::-webkit-scrollbar-track {
  background: #ff5b5b;
}
.events::-webkit-scrollbar-thumb {
  background: #71b6f9;
}
</style>
